import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';
//import { AvatarModule } from 'ngx-avatars';
import { AuthGuard } from 'src/app/guards/auth.guard';
import { CreateAuthGuard } from 'src/app/guards/create-auth.gaurd';
import { MaterialModule } from 'src/app/shared/material.module';
import { HomeModule } from '../home/home.module';
import { SettingsModule } from '../settings/settings.module';
import { InsOrgHeadersModule } from './components/instance-org-headers/ins-org-headers.module';
import { AddInstanceModule } from './components/instance/add-instance.module';
import { InstanceComponent } from './components/instance/instance/instance.component';
import { InstanceCardComponent } from './components/management-content-header/instance-card/instance-card.component';
import { InstanceContentComponent } from './components/management-content-header/instance-content/instance-content.component';
import { ManagementContentHeaderComponent } from './components/management-content-header/management-content-header.component';
import { OrganizationCardComponent } from './components/management-content-header/organization-card/organization-card.component';
import { OrganizationContentComponent } from './components/management-content-header/organization-content/organization-content.component';
import { ManagementContentMainHeaderComponent } from './components/management-content-main-header/management-content-main-header.component';
import { ManagementComponent } from './components/management/management.component';
import { ModalsModule } from './components/modals/organization/modals.module';
import { AzureAdDetailsComponent } from './components/organization/azure-ad-details/azure-ad-details.component';
import { OrganizationInstancesComponent } from './components/organization/organization-instances/organization-instances.component';
import { OrganizationUsersComponent } from './components/organization/organization-users/organization-users.component';
import { OrganizationWizardAddComponent } from './components/organization/organization-wizard-add/organization-wizard-add.component';
import { OrganizationWizardDetailsComponent } from './components/organization/organization-wizard-details/organization-wizard-details.component';
import { OrganizationComponent } from './components/organization/organization/organization.component';
import { UserTypeComponent } from './components/organization/user-type/user-type.component';
import { GuidCheck } from 'src/app/guards/Guid-check.gaurd';
import { NgbCarouselModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedModule } from 'src/app/shared/shared.module';

const routes: Routes = [
    {
        path: 'organization',
        component: OrganizationContentComponent,
    },
    {
        path: 'add-organization',
        component: OrganizationComponent,
        canActivate: [CreateAuthGuard],
    },
    {
        path: 'edit-organization/:id',
        component: OrganizationComponent,
        canActivate: [AuthGuard, GuidCheck],
    },
    { path: 'instance', component: InstanceContentComponent, canActivate: [GuidCheck] },
    {
        path: 'add-instance',
        component: InstanceComponent,
        canActivate: [CreateAuthGuard, GuidCheck],
    },
    {
        path: 'edit-instance/:id',
        component: InstanceComponent,
        canActivate: [AuthGuard, GuidCheck],
    },
];

@NgModule({
    declarations: [
        ManagementComponent,
        OrganizationComponent,
        ManagementContentHeaderComponent,
        OrganizationCardComponent,
        OrganizationWizardAddComponent,
        OrganizationWizardDetailsComponent,
        AzureAdDetailsComponent,
        UserTypeComponent,
        ManagementContentMainHeaderComponent,
        OrganizationUsersComponent,
        OrganizationInstancesComponent,
        InstanceContentComponent,
        InstanceCardComponent,
        OrganizationContentComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule,
        ModalsModule,
        RouterModule.forChild(routes),
        //AvatarModule,
        HomeModule,
        SettingsModule,
        TranslocoModule,
        AddInstanceModule,
        InsOrgHeadersModule,
        NgbCarouselModule,
        SharedModule,
    ],
    exports: [OrganizationComponent, ManagementContentHeaderComponent, OrganizationCardComponent],
})
export class ManagementModule {}
